// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DiscountDisclaimer-module-container-JI\\+\\+E header{margin-bottom:1rem}.DiscountDisclaimer-module-item-0Y06t:not(:first-child){margin-top:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "DiscountDisclaimer-module-container-JI++E",
	"item": "DiscountDisclaimer-module-item-0Y06t"
};
export default ___CSS_LOADER_EXPORT___;
